module.exports = __webpack_public_path__ + "static/media/Correct-answer.02882ce2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/music/Correct-answer.mp3
// module id = 859
// module chunks = 0